import CommonCss from "nlib/common/common.module.scss";

import Css from "./style.module.scss";

import AutoTooltip from "nlib/ui/AutoTooltip";
import Constants from "const/Constants";
import DataStatuses from "const/DataStatuses";
import DocumentPaymentTypes from "const/DocumentPaymentTypes";
import Money from "utils/Money";
import React from "react";

const AmountCell = ({ documentData }) => {
  const { status, paymentType, amountBase, amountVat, currency } = documentData;

  const value = (+amountBase || 0) + (+amountVat || 0);

  const buyPayment = paymentType === DocumentPaymentTypes.BUY;

  if (status === DataStatuses.TO_EXTRACT) return Constants.EMPTY_PLACEHOLDER;

  const content = Money.toMoneyString(value, currency);

  return (
    <div className={Css.amountCell}>
      <AutoTooltip
        className={(paymentType && (value || value === 0))
          ? CommonCss.coloredNumber
          : (paymentType ? "" : CommonCss.mediumDarkText)}
        data-negative={buyPayment ? "" : undefined}
        active={!!value}>
        {content}
      </AutoTooltip>
    </div>
  );
};

export default React.memo(AmountCell);
